<template>
  <div class="class-wrap">
    <div
      class="class-item"
      v-for="item in classList"
      :key="item.ID"
      @click="handleJump(item)"
    >
      <img
        :src="item.CLASS_ICON ? item.CLASS_ICON : getIco('homeicon')"
        class="ico"
        alt="class-icon"
      />
      <p class="text">
        {{ item.CLASS_NAME_MULTILINGUAL }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from "vue-router";
import { sdkOpenLink } from "@utiles/sdkCtrl";
import useModule from "@hooks/useModule";
import useLang from "@hooks/useLang";
import { getIco } from "@config/siteConfig";
const props = defineProps({
  classList: {
    default: [],
  },
  source: {
    default: "",
  },
});
const router = useRouter();
const route = useRoute();
const moduleName = route.meta.moduleName;
const { lang } = useLang();

const { getModuleById } = useModule();

const handleJump = (classItem) => {
  if (classItem?.REDIRECT_LINK) {
    sdkOpenLink({
      link: classItem.REDIRECT_LINK,
      openWay: classItem.REDIRECT_TYPE,
      loginDir: "1",
      appendParams: "1",
      source: props.source || "",
    });
    clickButtonPoint({
      btnName: `icon_golink`,
      moduleName: moduleName,
      otherParams: {
        classId: classItem.ID,
      },
    });
    return;
  }
  const moduleId = classItem.MODULE_ID;
  const targetModule = getModuleById(moduleId);
  if (!targetModule || targetModule.MODULE_ENNAME == moduleName) {
    return;
  }
  clickButtonPoint({
    btnName: `icon_${targetModule.MODULE_ENNAME}`,
    moduleName: moduleName,
    otherParams: {
      classId: classItem.ID,
      moduleId: moduleId,
    },
  });
  router.push({
    path: targetModule.MODULE_PATH,
    query: {
      classId: classItem.ID,
      source: props.source || "",
    },
  });
};
</script>

<style scoped lang="scss">
@import "@assets/scss/dimen.scss";
@import "@assets/scss/mixin.scss";
.class-wrap {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25%, 1fr));
  grid-auto-flow: row;
  gap: 0;
  justify-items: center;
  align-items: flex-start;
  margin-top: 55px;
  .class-item {
    display: flex;
    flex-direction: column;
    width: 187px;
    height: 111px;
    margin-bottom: 55px;
    cursor: pointer;
    align-items: center;
    @include addTouchEffect();
    .ico {
      height: 60px;
      margin: 0 auto 20px;
    }
    .text {
      font-size: $fzNormal;
      color: $titlecolor;
      width: 98%;
      text-align: center;
      word-break: break-all;
    }
  }
}
@media (orientation: landscape) {
  .class-wrap {
    grid-template-columns: repeat(auto-fit, minmax(33%, 1fr));

    .class-item {
      width: 100%;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .class-wrap {
    margin-top: calc(55px / $pcRate);
    .class-item {
      height: calc(111px / $pcRate);
      margin-bottom: calc(55px / $pcRate);
      .ico {
        height: calc(60px / $pcRate);
      }
      .text {
        font-size: $fzNormalPc;
      }
    }
  }
}
</style>
